import type { IconProps } from './types';
import './icons.css';

export default function Anonymized({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 45}
      height={height || 14}
      viewBox="0 0 45 14"
      className={`icon icon-arrow-down ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M.95 13.782V.98h2.714v1.018H2.181v10.767h1.483v1.018zm7.588-7.69q0-.718.506-1.224.513-.506 1.224-.506.717 0 1.223.506.513.505.513 1.224 0 .717-.513 1.23a1.67 1.67 0 0 1-1.223.506q-.711 0-1.224-.506a1.7 1.7 0 0 1-.506-1.23m4.908 0q0-.718.506-1.224.513-.506 1.224-.506.717 0 1.223.506.513.505.513 1.224 0 .717-.513 1.23a1.67 1.67 0 0 1-1.223.506q-.711 0-1.224-.506a1.7 1.7 0 0 1-.506-1.23m4.909 0q0-.718.505-1.224.513-.506 1.224-.506.718 0 1.224.506.512.505.512 1.224 0 .717-.512 1.23a1.67 1.67 0 0 1-1.224.506q-.711 0-1.224-.506a1.7 1.7 0 0 1-.505-1.23m4.908 0q0-.718.506-1.224.513-.506 1.223-.506.719 0 1.224.506.512.505.512 1.224 0 .717-.512 1.23a1.67 1.67 0 0 1-1.224.506q-.711 0-1.223-.506a1.7 1.7 0 0 1-.506-1.23m4.908 0q0-.718.506-1.224.513-.506 1.223-.506.718 0 1.224.506.513.505.513 1.224 0 .717-.513 1.23a1.67 1.67 0 0 1-1.224.506q-.71 0-1.223-.506a1.7 1.7 0 0 1-.506-1.23m4.908 0q0-.718.506-1.224.513-.506 1.224-.506.717 0 1.223.506.513.505.513 1.224 0 .717-.513 1.23a1.67 1.67 0 0 1-1.223.506q-.711 0-1.224-.506a1.7 1.7 0 0 1-.506-1.23m11.04 7.69h-2.714v-1.018h1.484V1.997h-1.484V.98h2.714z"
      />
    </svg>
  );
}
